import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth, setPersistence, browserSessionPersistence } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyAktQms_jJi-eLX7pEvgUb5g8HauOkxA18",
  authDomain: "byggerietspartner.firebaseapp.com",
  projectId: "byggerietspartner",
  storageBucket: "byggerietspartner.firebasestorage.app",
  messagingSenderId: "618416682696",
  appId: "1:618416682696:web:41a26c0aa0e7e847ee17fd",
  measurementId: "G-LJ7XZQMP50"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

// Sæt persistence til session (ryddes når browseren lukkes)
setPersistence(auth, browserSessionPersistence)
  .then(() => {
    console.log('Session persistence sat korrekt');
  })
  .catch((error) => {
    console.error('Fejl ved sætning af session persistence:', error);
  });

export { db, auth, storage };